import { gql, useMutation, useQuery } from '@apollo/client';
import { CheckCircleIcon } from '@heroicons/react/outline';
import React, { useContext, useState } from 'react';
import { useEffect } from 'react';
import getModalContext from '../../context/getModalContext';
import { Account_AccountData_account } from '../../types/graph/Account_AccountData';
import ActiveSubscription from './Billing/ActiveSubscription';
import PaymentCards from './Billing/PaymentCards';
import SubscriptionGrid from './Billing/SubscriptionGrid';
import Subscriptions from './Billing/Subscriptions';

interface IProps {
  account: Account_AccountData_account;
}

const Billing: React.FC<IProps> = ({ account }) => {
  const modals = useContext(getModalContext());

  const [activeProduct, setActiveProduct] = useState<any>(null);

  const { data, loading, error } = useQuery(GET_PRODUCTS);

  const [createBillingPortalSession] = useMutation(
    CREATE_BILLING_PORTAL_SESSION,
    {
      onCompleted: (data) => {
        //redirect
        console.log(data);
        window.location.replace(data.createBillingPortalSession.url);
      },
    }
  );

  useEffect(() => {
    if (data) {
      for (const product of data.products) {
        if (product.active && !product.default) {
          setActiveProduct(product);
        }
      }
    }
  }, [data, setActiveProduct]);

  const handleOpenBillingPortal = () => {
    createBillingPortalSession({
      variables: {
        accountId: account.id,
      },
    });
  };

  if (!data || loading || error) return null;

  return (
    <div className="pb-12 h-full shadow rounded-lg bg-white">
      <div className="py-6 px-4 sm:p-6 lg:pb-8">
        <div className="flex justify-between">
          <div>
            <h2 className="text-lg leading-6 font-medium text-gray-900">
              Billing
            </h2>
            <p className="mt-1 text-sm text-gray-500">Manage account billing</p>
          </div>
          <div className="mt-1">
            <button
              className="ml-3 inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-light"
              onClick={handleOpenBillingPortal}
            >
              Access Billing Details
            </button>
          </div>
        </div>

        <div className="">
          {activeProduct ? (
            // <div className="w-72 mx-auto border-gray-300 relative bg-white border rounded-lg shadow-sm p-4 flex cursor-pointer focus:outline-none">
            //   <div className="flex-1 flex">
            //     <div className="flex flex-col">
            //       <span className="block text-sm font-medium text-gray-900">
            //         {activeProduct.name}
            //       </span>
            //       <span className="mt-1 flex items-center text-sm text-gray-500">
            //         {activeProduct.description}
            //       </span>
            //       <span className="mt-6 text-xs font-medium text-gray-900">
            //         {activeProduct.details}
            //       </span>
            //     </div>
            //   </div>
            //   <CheckCircleIcon className="h-5 w-5 text-primary" />
            //   <div className="border border-primary-light absolute -inset-px rounded-lg pointer-events-none" />
            // </div>
            <ActiveSubscription
              product={activeProduct}
              handleChange={handleOpenBillingPortal}
            />
          ) : (
            <SubscriptionGrid account={account} products={data.products} />
            // <Subscriptions account={account} products={data.products} />
          )}
        </div>
      </div>
      {/* <div className="px-4 py-3 bg-gray-50 text-right sm:px-6 rounded-b-lg">
        <button
          className="bg-white border border-gray-300 rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-light"
          onClick={() => {
            modals?.setModalState('paymentModal', true, { account });
          }}
        >
          Open Payment Modal
        </button>
      </div> */}
    </div>
  );
};

export default Billing;

const CREATE_BILLING_PORTAL_SESSION = gql`
  mutation AccountBilling_createBillingPortalSession($accountId: String!) {
    createBillingPortalSession(accountId: $accountId) {
      url
    }
  }
`;

const GET_PRODUCTS = gql`
  query AccountBilling_getProductsData {
    products {
      productId
      priceId
      type
      recurrence
      name
      description
      details
      features
      amount
      default
      active
    }
  }
`;
